import React from "react";
import { Text } from "react-native";

const AVText = ({ children, ...props }) => {
	return <Text style={{ fontFamily: "Roboto", ...props }}>{children}</Text>;
};

export default AVText;
